export const GET_ALL_COUNTRIES = "GET_ALL_COUNTRIES"
export const GET_ALL_ACTIVITIES = "GET_ALL_ACTIVITIES"

export const POST_ACTIVITY = "POST_ACTIVITY"

export const GET_COUNTRY_BY_ID = "GET_COUNTRY_BY_ID"
export const GET_COUNTRY_BY_NAME = "GET_COUNTRY_BY_NAME"

export const FILTER_BY_CONTINENT = "FILTER_BY_CONTINENT"
export const FILTER_BY_ACTIVITY = "FILTER_BY_ACTIVITY"
export const ALPHABETIC_ORDER = "ALPHABETIC_ORDER"
export const POPULATION_ORDER = "POPULATION_ORDER"
export const FILTER_STATE = "FILTER_STATE"

